module.exports = __webpack_public_path__ + "img/grid.33188189.svg";